import { Route, Switch } from "react-router-dom";
import UsuarioListagemPage from "./Listagem";

function UsuariosPages() {
  return (
    <Switch>
      <Route path="/usuarios" component={UsuarioListagemPage} />
    </Switch>
  );
}

export default UsuariosPages;
